import { CompositionChildEditPreviewDto } from '@app/modules/compose/composition.types';

/**
 * Returns the thumbnail URL for a composition list card: walks `edits` from the last
 * index toward the first and returns the first non-empty string `thumbnailUrl` (API order).
 */
export function getCompositionListThumbnailSrc(
  edits: CompositionChildEditPreviewDto[],
): string | null {
  for (let i = edits.length - 1; i >= 0; i -= 1) {
    // OpenAPI types thumbnailUrl as object; runtime value is a URL string (same as edit cards).
    const url: unknown = edits[i].thumbnailUrl;
    if (typeof url === 'string' && url.length > 0) {
      return url;
    }
  }
  return null;
}
